import React, {useReducer, useState} from 'react';
import {Row, LeftCell, RightCell, SwitchComponent } from 'components/layout/Misc';
import {Dropdown} from "semantic-ui-react";
import pageComponents from "../layout/PageComponents";


const renderComponent = (component, stateSetter, state) => {

  switch (component.type) {
    case "switch":
      return (<SwitchComponent
        setState={stateSetter}
        componentState={state}
        componentStateProperty={component.stateProperty}
      />)
    case "select":
      return (<Dropdown
        clearable
        selection
        onChange={(evt, selector) => {
          let state = {}
          state[component.stateProperty] = selector.value
          stateSetter(state)
        }}
        options={component.options}
        value={state} />)

    case "multi-select":
      return (<Dropdown
        multiple
        selection
        options={component.options}
        onChange={(evt, selector) => {
          let state = {}
          state[component.stateProperty] = selector.value
          stateSetter(state)
        }}
      />)
  }
}

export default ({setMapOptions, layers, sectionConfig}) => {

  const setSectionMapOptions = (options) => {
    let state = {}
    state[sectionConfig.section] = {
      ...layers,
      ...options
    }
    setMapOptions(state)
  }

  const setHiddenSectionMapOptions = (options) => {
    let state = {}
    state[sectionConfig.section] = {
      ...layers,
      ...options
    }
    setMapOptions(state)
  } 

  return (
    <div>
      {
        sectionConfig.components.map((component, key) => {
          if (component.isVisible) {
            if (! component.isVisible(layers)) {
              return
            }
          }


          if (component.filter instanceof Function) {
            component.options = component.allOptions.filter((option) => {return component.filter(option, layers)})
          }

          if (component.type == 'hidden') {
            if (component.options.length === 1) {
              if (layers[component.stateProperty] != component.options[0].value) {
                let state = {}
                state[component.stateProperty] = component.options[0].value
                setHiddenSectionMapOptions(state)
              }
            } 
            else if (component.options.length === 0) {
              if (layers[component.stateProperty] !== null && layers[component.stateProperty] !== false) {
                let state = {}
                state[component.stateProperty] = null
                console.log("ug", layers[component.stateProperty])
                setSectionMapOptions(state)
              }
            }
            return
          }

          return (
            <Row key={key}>
              <LeftCell>{component.text}</LeftCell>
              <RightCell>
                {renderComponent(component, setSectionMapOptions, layers[component.stateProperty])}
              </RightCell>
            </Row>
          )
        })
      }

    </div>
  )
}